



















































































































































import { Component, Vue } from "vue-property-decorator";
import cambioscontrasenasperdidasModule from "@/store/modules/cambioscontrasenasperdidas-module";
import { cambioscontrasenasperdidas } from "@/shared/dtos/cambioscontrasenasperdidas";
import { UtilsString } from "@/utils/utils-string";
import { AppConfig } from "@/config/app";
import { MessageService } from "@/shared/services/message-service";
import { UtilsURLS } from "@/utils/utils-urls";
import { ThemeConfig } from "@/config/theme";

@Component
export default class PwdLost extends Vue {
  private objpwslost = new cambioscontrasenasperdidas();
  private verMensaje = false;
  private changePwdAutomatico = false;
  private loading = false;
  private error: string | null = null;
  private appName = AppConfig.name;

  get projectName() {
    return process.env.VUE_APP_TITLE || AppConfig.name || "App Base";
  }

  get clientLogo() {
    return UtilsURLS.urls("logo_cliente.png");
  }

  created() {
    if (UtilsString.IsValidParamUrl(this.$route.params.email)) {
      this.changePwdAutomatico = true;
      this.objpwslost.email = this.$route.params.email;
      setTimeout(() => this.submit(), 250);
    }
  }

  private validateEmail(email: string): boolean {
    const re = /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/;
    return re.test(email);
  }

  private async submit() {
    if (!this.validateEmail(this.objpwslost.email)) {
      this.error = "Por favor, introduce un correo electrónico válido.";
      return;
    }
    this.error = null;
    this.loading = true;
    this.objpwslost.url_production = window.location.href.replace(
      "lostpwd",
      ""
    );
    try {
      await cambioscontrasenasperdidasModule.guardarcambioscontrasenasperdidas(
        this.objpwslost
      );
      this.verMensaje = true;
      MessageService.toast("Instrucciones enviadas", "success");
    } catch (e) {
      this.error =
        "Ocurrió un error al procesar tu solicitud. Intenta nuevamente más tarde.";
      MessageService.toast("Error al procesar solicitud", "error");
    } finally {
      this.loading = false;
    }
  }
}
